import * as mutations from 'src/graphql/mutations'
import { graphqlApi } from 'src/redux/api/graphql/graphqlApi'
import { API, graphqlOperation } from 'src/utils/amplify/legacy'
import { getErrorMessage } from 'src/utils/error'

interface SendInvoiceToBillitArgs {
	tenantId: string
	invoiceId: string
}

interface SendInvoiceToBillitResponse {
	status: string
	message: string
}

export const billitApi = graphqlApi.injectEndpoints({
	endpoints: (builder) => ({
		sendInvoiceToBillit: builder.mutation<
			SendInvoiceToBillitResponse,
			SendInvoiceToBillitArgs
		>({
			queryFn: async ({ tenantId, invoiceId }) => {
				try {
					const response = (await API.graphql(
						graphqlOperation(mutations.sendInvoiceToBillit, {
							tenantId,
							invoiceId,
						})
					)) as {
						data: {
							sendInvoiceToBillit: SendInvoiceToBillitResponse
						}
					}
					const result = response.data.sendInvoiceToBillit
					if (result.status === 'error') {
						return { error: result.message }
					}
					return { data: result }
				} catch (error) {
					const errMsg = getErrorMessage(error)
					return { error: errMsg }
				}
			},
		}),
	}),
	overrideExisting: false,
})

export const { useSendInvoiceToBillitMutation } = billitApi
